// Colors
export const socotraBlue1 = '#3675A1';
export const socotraBlue2 = '#314974';
export const socotraBlue2Faded = 'rgba(49, 73, 116, .16)';
export const socotraBlue3 = '#74C2CD';
export const socotraOrange = '#E49142';
export const socotraGray1 = '#6B747F';
export const socotraGray2 = '#414042';
export const socotraGreen = 'rgb(35, 178, 142)';
export const socotraGreenFaded = 'rgb(35, 178, 142, 0.1)';
export const lightGray = '#D3D3D3';
// Layout
export const headerHeightNo = 68;
export const headerHeight = `${headerHeightNo}px`;
export const pageTitleSize = '18px';
export const topContainerHeightNo = 56;
export const topContainerHeight = `${topContainerHeightNo}px`;
